import React from 'react';
import { useI18n } from '../i18n';
import { Icon } from './Icon';

export interface ReconnectModalProps {
  roomId: string | null;
  lastRoomId: string | null;
  onRetry: () => void;
  onLeave: () => void;
}

export const ReconnectModal: React.FC<ReconnectModalProps> = ({
  roomId,
  lastRoomId,
  onRetry,
  onLeave,
}) => {
  const { lang } = useI18n();
  const isMn = lang === 'mn';
  const displayRoomId = roomId ?? lastRoomId;

  return (
    <div
      className="reconnect-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={isMn ? 'Холболт сэргээж байна' : 'Reconnecting to game'}
    >
      <div className="reconnect-modal-card">
        <div className="reconnect-radar-container" aria-hidden="true">
          <div className="reconnect-radar-ring" />
          <div className="reconnect-radar-core">
            <svg
              className="reconnect-wifi-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="24"
              height="24"
            >
              <path d="M5 13a10 10 0 0 1 14 0" />
              <path d="M8.5 16.5a5 5 0 0 1 7 0" />
              <line x1="12" y1="20" x2="12.01" y2="20" />
            </svg>
          </div>
        </div>

        <h2 className="reconnect-title">
          {isMn ? 'Холболт сэргээж байна...' : 'Restoring Connection...'}
        </h2>

        {displayRoomId && (
          <div className="reconnect-room-badge">
            <span className="reconnect-badge-dot" aria-hidden="true" />
            <span>{isMn ? `Өрөө: ${displayRoomId}` : `Room: ${displayRoomId}`}</span>
          </div>
        )}

        <p className="reconnect-desc">
          {isMn
            ? 'Таны тоглоомын явц болон моднууд хадгалагдсан байгаа тул түр хүлээнэ үү.'
            : 'Your game progress and hand are preserved. Hang tight while we re-establish connection.'}
        </p>

        <div className="reconnect-actions">
          <button
            type="button"
            className="reconnect-btn-primary"
            onClick={onRetry}
          >
            <Icon name="rotate-ccw" size={16} />
            <span>{isMn ? 'Дахин оролдох' : 'Retry Now'}</span>
          </button>

          <button
            type="button"
            className="reconnect-btn-secondary"
            onClick={onLeave}
          >
            <Icon name="log-out" size={15} />
            <span>{isMn ? 'Өрөөнөөс гарах' : 'Return Home'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
